<div class="grid grid-cols-1 grid-rows-4">
  @for (side of sideList(); track side.id) {
    <lib-perio-position-indicator-side [side]="side" [jaw]="side.jaw" (toothClick)="onToothClick($event)"></lib-perio-position-indicator-side>
  }
</div>
